import { render, staticRenderFns } from "./TonIndex.vue?vue&type=template&id=0c8b1aed&scoped=true&"
import script from "./TonIndex.vue?vue&type=script&lang=js&"
export * from "./TonIndex.vue?vue&type=script&lang=js&"
import style0 from "./TonIndex.vue?vue&type=style&index=0&id=0c8b1aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b1aed",
  null
  
)

export default component.exports